import Icon from '@expo/vector-icons/FontAwesome5';
import React, { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { Row } from './Row';
import { TextRow } from './TextRow';
import { styles } from './styles';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { Divider } from 'react-native-elements';
import colors from '@/config/colors';
import { Modal } from '@/components/ui/therapist/Modal';
import { ScrollView } from 'react-native-gesture-handler';
import { Button } from '@/components/ui/therapist/Button';
import { Pagination } from '@/components/ui/therapist/Pagination';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { IS_ANDROID } from '@/utils/platform';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export function Options({
  title,
  data,
  selectedData,
  pureSelectedData,
  dataCount,
  onPress,
  headerPress,
  isEmptyText,
  page,
  maxPage,
  handlePageChange,
  selectedLimit,
  isTextSet,
  textLength,
}) {
  const activeTextLength = textLength;
  const insets = useSafeAreaInsets();

  const [textModal, setTextModal] = useState({
    isShown: false,
    data: null,
  });

  const handleTextClick = useCallback((data) => {
    setTextModal({
      isShown: true,
      data,
    });
  }, []);

  const handleClose = useCallback(() => {
    setTextModal({
      isShown: false,
      data: null,
    });
  }, []);

  return (
    <View style={[styles.containerItem]}>
      <View style={styles.containerItemHeader}>
        <View style={styles.containerItemHeaderText}>
          <Text style={styles.title}>{title || 'Options'}</Text>
          <Text style={styles.titleSize}> {dataCount}</Text>
        </View>
        <PressableNeolexon onPress={headerPress}>
          <View
            style={[
              styles.containerItemHeaderBtn,
              { backgroundColor: colors.newUI.therapist.primaryBlue80 },
            ]}
          >
            <Icon name="copy" size={20} color="white" />
          </View>
        </PressableNeolexon>
      </View>
      <KeyboardAwareScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ flexGrow: 1 }}
        enableOnAndroid={true}
        extraScrollHeight={IS_ANDROID ? insets.bottom + 150 : 0}
      >
        <View style={styles.containerItemBody}>
          {data.length == 0 ? (
            <Text style={refinement.textStyle}>{isEmptyText}</Text>
          ) : null}
          {data.map((eachData) => {
            if (isTextSet) {
              const { title, _id, simpleBody, body, tags, textLength } =
                eachData;
              const tagsArray = tags?.[0]?.displayHierarchy?.split('/') || [];
              const isSelected = () => {
                if (selectedData.includes(_id)) {
                  const foundData = pureSelectedData.find((d) => {
                    return d._id == _id && d.textLength === activeTextLength;
                  });
                  if (!foundData) {
                    return false;
                  }
                  return true;
                } else {
                  return false;
                }
              };

              return (
                <React.Fragment key={_id}>
                  <TextRow
                    isSelected={isSelected()}
                    wholeObject={eachData}
                    simpleBody={simpleBody}
                    body={body}
                    hasTags
                    title={title}
                    textLength={textLength}
                    tags={tagsArray}
                    onPress={onPress}
                    selectedLimit={selectedLimit}
                    handleTextClick={handleTextClick}
                  />
                  <Divider width={2} color={colors.grey} />
                </React.Fragment>
              );
            } else {
              const { _id, pictures, print, tags } = eachData;
              const hasImage = pictures.length > 0;
              const title = print;
              const hierarchies =
                tags
                  ?.map((tag) => tag.displayHierarchy)
                  .flatMap((displayHierarchy) => displayHierarchy.split('/')) ||
                [];
              const tagsArray = [...new Set(hierarchies)];
              const isSelected = selectedData.includes(_id);

              return (
                <React.Fragment key={_id}>
                  <Row
                    isSelected={isSelected}
                    wholeObject={eachData}
                    isTextSet={false}
                    hasImage={hasImage}
                    hasTags
                    imageURL={pictures[0].appimage_url}
                    title={title}
                    tags={tagsArray}
                    onPress={onPress}
                    selectedLimit={selectedLimit}
                  />
                  <Divider width={2} color={colors.grey} />
                </React.Fragment>
              );
            }
          })}
          <Pagination
            currentPage={parseInt(page)}
            totalPages={maxPage}
            onPageChange={(newPage) => handlePageChange(null)(newPage)}
          />

          <Modal
            onClose={handleClose}
            isVisible={textModal.isShown}
            cancelActionButton={
              <Button
                label="Schließen"
                style={{ fontSize: 16 }}
                onPress={handleClose}
              />
            }
            title={textModal.data?.header}
          >
            <ScrollView style={{ maxHeight: 400 }}>
              <Text style={{ fontSize: 20 }}>{textModal.data?.body}</Text>
            </ScrollView>
          </Modal>
        </View>
      </KeyboardAwareScrollView>
    </View>
  );
}

const refinement = StyleSheet.create({
  textStyle: {
    marginVertical: 5,
    marginHorizontal: 15,
  },
});
